export default __webpack_public_path__ + "static/media/foto5.7b825bd5.jpg";